var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center items-center"},[_c('p',{staticClass:"text-mainblack"},[_vm._v("Powered by "),_c('span',{staticClass:"text-primary"},[_vm._v("Vitel Health")])])])
}]

export { render, staticRenderFns }